<div class="ibercaja-upload-container">
  <div class="header">
    <button class="btn-back" (click)="goBack()">← Volver</button>
    <h1>Envío ficheros Ibercaja</h1>
  </div>

  <div class="content">
    <div class="description-box">
      <p>Con esta herramienta puedes generar los ficheros AC/TF y ficheros de tasaciones para Ibercaja cargando un fichero CSV con los IDs de tasación</p>
    </div>

    <!-- CSV File Selection -->
    <div class="form-section">
      <label class="form-label">Archivo CSV con IDs</label>
      <div class="input-group">
        <input
          type="text"
          class="form-input"
          [value]="csvFilePath()"
          readonly
          placeholder="Selecciona un archivo CSV con IDs..."
        />
        <button class="btn-browse" (click)="selectCsvFile()">Examinar</button>
        <button class="btn-download" (click)="downloadExampleCsv()" title="Descargar CSV de ejemplo">
          ⬇ Ejemplo
        </button>
      </div>
    </div>

    <!-- Options Section -->
    <div class="form-section">
      <label class="form-label">Email de notificación</label>
      <input
        type="email"
        class="form-input form-input-full"
        [(ngModel)]="email"
        placeholder="Introduce el email para recibir la notificación..."
      />
    </div>

    <div class="form-section">
      <label class="form-label">Opciones</label>
      <div class="options-group">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="includeCertificates" />
          <span>Incluir certificados</span>
        </label>
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="ignoreValidation" />
          <span>Ignorar validación</span>
        </label>
      </div>
      <div class="format-group">
        <label class="form-label">Formato</label>
        <select class="form-select" [(ngModel)]="format">
          @for (formatOption of formatOptions; track formatOption.value) {
            <option [value]="formatOption.value">
              {{ formatOption.value }} = {{ formatOption.label }}
            </option>
          }
        </select>
      </div>
    </div>

    <!-- Error Message -->
    @if (errorMessage()) {
      <div class="error-box">
        <strong>Error:</strong> {{ errorMessage() }}
      </div>
    }

    <!-- Success Message -->
    @if (successMessage()) {
      <div class="success-box">
        <strong>Éxito:</strong> {{ successMessage() }}
      </div>
    }

    <!-- IDs Preview -->
    @if (appraisalIds().length > 0) {
      <div class="table-section">
        <h3 class="table-title">IDs cargados ({{ appraisalIds().length }} registros)</h3>
        <div class="ids-preview">
          {{ appraisalIds().join(', ') }}
        </div>

        <div class="button-container">
          <button
            class="btn-submit"
            [disabled]="isSending() || !email"
            (click)="sendRequest()">
            @if (isSending()) {
              Enviando...
            } @else {
              Enviar
            }
          </button>
        </div>
      </div>
    }
  </div>
</div>
